import React from "react";
import Typography from "@mui/material/Typography";

export const About = (props) => {
  return (
    <Typography sx={{ mt: "1em", ml: "2em" }} color="primary">
      Simply Order v 1.0
    </Typography>
  );
};
